import DiamondIcon from "@mui/icons-material/Diamond";
import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
import SpeedIcon from "@mui/icons-material/Speed";

export const testimonialsMetaData = [
  {
    rating: 4,
    profile:
      "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1180&q=80",
    name: "Paul Star",
    review:
      "Good to have transportation available in places and times it is otherwise hard to find, but the app has always been a bit difficult to use especially how it works or doesn't with large font phone settings",
  },
  {
    rating: 3,
    profile:
      "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1180&q=80",
    name: "John Clein",
    review:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Culpa sit rerum incidunt, a consequuntur recusandae ab saepe illo est quia obcaecati neque quibusdam eius accusamus error officiis atque voluptates magnam!",
  },
  {
    rating: 5,
    profile:
      "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1180&q=80",
    name: "Kayle Morsse",
    review:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Culpa sit rerum incidunt, a consequuntur recusandae ab saepe illo est quia obcaecati neque quibusdam eius accusamus error officiis atque voluptates magnam!",
  },
  {
    rating: 4,
    profile:
      "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1180&q=80",
    name: "Yuvika Gupta",
    review:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Culpa sit rerum incidunt, a consequuntur recusandae ab saepe illo est quia obcaecati neque quibusdam eius accusamus error officiis atque voluptates magnam!",
  },
];

export const whyRideWithUs = [
  {
    name: "Safe Guarantee",
    description: "We successfully cope with tasks of varying complexity!",
    icon: <DiamondIcon className="!w-8 !h-8" />,
  },
  {
    name: "Fast Pickups",
    description: "We successfully cope with tasks of varying complexity!",
    icon: <DirectionsCarFilledIcon className="!w-8 !h-8" />,
  },
  {
    name: "Quick Ride",
    description: "We successfully cope with tasks of varying complexity!",
    icon: <SpeedIcon className="!w-8 !h-8" />,
  },
];
